export const messages = {
  en: {
    reportCustomComponentRel: {
      component: 'Component',
      back: 'Back',
      associateComponent: 'Associate Component',
      relId: 'Relation ID',
      reportId: 'Report ID',
      componentSeq: 'Component Sequence',
      associateTime: 'Associate Time',
      operation: 'Operation',
      delete: 'Delete',
      confirmDelete: 'Confirm to delete report component relation?'
    },
    addReportCustomComponentRel: {
      associate: 'Associate',
      component: 'Component',
      componentRequired: 'Required, please enter component ID',
      componentMaxLength: 'Component ID cannot exceed 30 characters',
      reportIdRequired: 'Report ID is required',
      reportIdMaxLength: 'Report ID cannot exceed 30 characters',
      componentSeq: 'Component Sequence',
      seqRequired: 'Required, please enter component sequence',
      seqMaxLength: 'Component sequence cannot exceed 11 characters',
      chooseComponent: 'Choose Component',
      cancel: 'Cancel',
      save: 'Save'
    },
    chooseReportCustomComponent: {
      chooseReportComponent: 'Choose Report Component',
      inputComponentName: 'Enter report component name',
      search: 'Search',
      componentId: 'Component ID',
      componentName: 'Component Name',
      componentType: 'Component Type',
      queryModel: 'Query Model',
      description: 'Description',
      operation: 'Operation',
      choose: 'Choose'
    },
    deleteReportCustomComponentRel: {
      confirmOperation: 'Please confirm your operation',
      confirmDelete: 'Confirm to delete report component relation?',
      cancel: 'Cancel',
      confirmDeleteBtn: 'Confirm Delete'
    }
  },
  zh: {
    reportCustomComponentRel: {
      component: '组件',
      back: '返回',
      associateComponent: '关联组件',
      relId: '关系编号',
      reportId: '报表编号',
      componentSeq: '组件序号',
      associateTime: '关联时间',
      operation: '操作',
      delete: '删除',
      confirmDelete: '确定删除报表组件关系?'
    },
    addReportCustomComponentRel: {
      associate: '关联',
      component: '组件',
      componentRequired: '必填，请填写组件ID',
      componentMaxLength: '组件ID不能超过30个字符',
      reportIdRequired: '报表编号不能为空',
      reportIdMaxLength: '报表编号不能超过30个字符',
      componentSeq: '组件序号',
      seqRequired: '必填，请填写组件序号',
      seqMaxLength: '组件序号不能超过11个字符',
      chooseComponent: '选择组件',
      cancel: '取消',
      save: '保存'
    },
    chooseReportCustomComponent: {
      chooseReportComponent: '选择报表组件',
      inputComponentName: '输入报表组件名称',
      search: '查询',
      componentId: '组件ID',
      componentName: '组件名称',
      componentType: '组件类型',
      queryModel: '查询方式',
      description: '描述',
      operation: '操作',
      choose: '选择'
    },
    deleteReportCustomComponentRel: {
      confirmOperation: '请确认您的操作',
      confirmDelete: '确定删除报表组件关系?',
      cancel: '点错了',
      confirmDeleteBtn: '确认删除'
    }
  }
}